export const IconRepeat: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22951_15503)">
      <path
        d="M10.4917 4.99984L12.1584 3.33317L10.4917 1.6665"
        stroke="#3D86E0"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.50846 15L7.8418 16.6667L9.50846 18.3333"
        stroke="#3D86E0"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7287 5.30908C15.9245 6.51408 16.667 8.16825 16.667 9.99992C16.667 13.6816 13.682 16.6666 10.0004 16.6666C9.34538 16.6666 8.71454 16.5682 8.11621 16.3924"
        stroke="#3D86E0"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.21183 14.6347C4.05016 13.4347 3.3335 11.8013 3.3335 9.99967C3.3335 6.31801 6.3185 3.33301 10.0002 3.33301C10.6552 3.33301 11.286 3.43134 11.8843 3.60717"
        stroke="#3D86E0"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22951_15503">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
